import React, { useState, useCallback, useEffect } from "react";
import { toast } from "react-toastify";
import { toastProperties } from "../../../commons/Toast/Toaster";
import {
  addConsumer,
  updateConsumer,
} from "../../../Services/CompanyAdmin/AllApiAdmin";
import {
  addConsumerSuperAdmin,
  updateConsumerSuperAdmin,
} from "../../../Services/GNA/AlterApi";
import { useDispatch, useSelector } from "react-redux";
import {
  fetchConsumer,
  fetchConsumers,
  fetchGeneratorDetails,
} from "../../../Redux/Slices/companyAdminSlice";
import { fetchConsumersCompanyId } from "../../../Redux/Slices/gnaAdminSlice";
import Styles from "../../Auth/Register/Elements/Element.module.css";
import Fileupload from "../../../commons/Inputs/FileUpload/Fileupload";
import TextInput from "../../../commons/Inputs/TextInput/TextInput";
import SelectInput from "../../../commons/Inputs/Select/SelectInput";
import { Add, Close } from "@mui/icons-material";
import {
  publicCityById,
  publicDiscomByStateId,
  publicStateByRegionId,
  publicVoltage,
  publicRegion,
  publicDiscom,
  publicStateUT,
  publicSpecefication,
} from "../../../Redux/Slices/publicSlice";
import { ReactComponent as RemoveIcon } from "../../../assets/images/Remove.svg";
import {
  fetchSideBarConsumerList,
  fetchSideBarGeneratorsList,
} from "../../../Redux/Slices/CapacitySlice";
import {
  getWalletAccountsByCompanies,
  walletAccountCreate,
} from "../../../Services/Payments/PaymentApi";
import { id } from "date-fns/locale";
import { useLocation } from "react-router-dom";

const AddressSection = ({
  prefix,
  addressData,
  handleChange,
  errors,
  publicData,
  index,
}) => {
  const dispatch = useDispatch();

  const handleGetCityByStateId = useCallback(
    (index, field, value) => {
      dispatch(publicCityById(value?.id));
      handleChange(index, field, value);
    },
    [dispatch, handleChange],
  );
  const renderTextInput = (
    field,
    heading,
    example,
    type = "text",
    readOnly = false,
  ) => (
    <TextInput
      heading={`${heading} `}
      value={addressData[field]}
      onChange={(value) => handleChange(index, field, value)}
      example={example}
      type={type}
      height="45"
      error={errors[`${field}_${index}`]}
      readOnly={readOnly}
    />
  );

  const renderSelectInput = (field, heading, list, example) => (
    <SelectInput
      onChange={(value) =>
        heading === "State"
          ? handleGetCityByStateId(index, field, value)
          : handleChange(index, field, value)
      }
      list={list}
      value={addressData[field]}
      example={example}
      heading={`${heading} `}
      height="45px"
      error={errors[`${field}_${index}`]}
    />
  );

  return (
    <>
      <div className={Styles.layer1ElementsContainer}>
        {renderTextInput(`${prefix}_address`, "Full Address", `Enter Address`)}
      </div>
      <div className={Styles.layer3ElementsContainer}>
        {renderTextInput(`${prefix}_pincode`, "Pin Code", "Enter Pincode")}
        {renderSelectInput(
          `${prefix}_state`,
          "State",
          publicData?.stateUT,
          "Eg. Select State",
        )}
        {renderSelectInput(
          `${prefix}_city`,
          "City",
          publicData?.city?.filter(
            (ele) => ele?.stateUtId === addressData[`${prefix}_state`]?.id,
          ),
          "Eg. Select City",
        )}
      </div>

      <div className={Styles.layer2ElementsContainer}>
        {renderTextInput(
          `${prefix}_contact`,
          "Name of the Contact Person",
          "Enter Contact Person Name",
        )}
        {renderTextInput(`${prefix}_email`, "Email", "Enter Email")}
      </div>
      <div className={Styles.layer2ElementsContainer}>
        {renderTextInput(`${prefix}_mobile`, "Mobile No.", "Enter Mobile No.")}
        {renderTextInput(
          `${prefix}_altMobile`,
          "Alternate Mobile No.",
          "Enter Alternate Mobile No.",
        )}
      </div>
    </>
  );
};

const CompanyAdminConsumerForm = ({
  handleClose,
  onSwitchToGenerator,
  editMode = false,
  entityData = null,
  entityId = null,
  email = "",
  user = { case: "company_admin", value: ["COMPANY_ADMIN"] },
  isModal = false,
  isSuperAdmin = false,
  companyId = null,
  hideSelection = false,
}) => {
  const dispatch = useDispatch();
  const publicData = useSelector((state) => state?.publicSlice);
  const authUser = useSelector((state) => state?.persistedReducer?.user);
  const [sameCheck, setSameCheck] = useState("same");
  const [sameBank, setSameBank] = useState(true);

  const location = useLocation();
  const searchParams = new URLSearchParams(location.search);
  const companyIdFromUrl = searchParams.get("id");

  const initialConsumerDetail = useCallback(() => {
    if (editMode && entityData) {
      const consumerData =
        entityData?.data?.data || entityData?.data || entityData;

      const officeAddress = consumerData.consumerOfficeAddress || {};
      const correspondenceAddress =
        consumerData.consumerCorrespondenceAddress || {};

      const specificationObj =
        publicData?.specification?.find(
          (ele) => ele.id === consumerData.specificationId,
        ) || null;

      const regionObj = consumerData?.regionId
        ? publicData?.region?.find(
            (region) => region.id === consumerData.regionId,
          )
        : null;

      const stateObj = consumerData?.stateUtId
        ? publicData?.stateUT?.find(
            (state) => state.id === consumerData.stateUtId,
          )
        : null;

      const registeredStateObj = officeAddress.stateUtId
        ? publicData?.stateUT?.find(
            (state) => state.id === officeAddress.stateUtId,
          )
        : null;

      const registeredCityObj = officeAddress.cityId
        ? publicData?.city?.find((city) => city.id === officeAddress.cityId)
        : null;

      const correspondenceStateObj = correspondenceAddress.stateUtId
        ? publicData?.stateUT?.find(
            (state) => state.id === correspondenceAddress.stateUtId,
          )
        : null;

      const correspondenceCityObj = correspondenceAddress.cityId
        ? publicData?.city?.find(
            (city) => city.id === correspondenceAddress.cityId,
          )
        : null;

      return {
        plantName: consumerData?.consumerName || "",
        maxDrawal: consumerData?.maxCapDrawl?.toString() || "",
        poi: consumerData?.pointValue || "DISCOM",
        pod: consumerData?.pointValue
          ? { label: consumerData?.pointValue, value: consumerData?.pointValue }
          : { label: "DISCOM", value: "DISCOM" },
        specification: specificationObj,
        region: regionObj,
        state: stateObj,
        discom: Array.isArray(consumerData?.discomDetails)
          ? consumerData?.discomDetails
              .filter((item) => item != null && typeof item === "object")
              .map((item) => {
                const discomObj = publicData?.discom?.find(
                  (discom) => discom.id === item.discomId,
                );

                return {
                  discomId: discomObj || { id: item.discomId },
                  voltage: item.voltageLevel
                    ? {
                        level: item.voltageLevel,
                        name: item.voltageLevel,
                        id: item.voltageLevel,
                      }
                    : null,
                };
              })
          : [],
        discomName: {},
        discomVoltage: Array.isArray(consumerData?.discomDetails)
          ? consumerData.discomDetails
              .filter((item) => item != null && typeof item === "object")
              .map((item) => {
                const discomObj = publicData?.discom?.find(
                  (d) => d.id === item.discomId,
                );
                const voltageLevel = item.voltageLevel;

                return {
                  discomId: discomObj || null,
                  voltage: voltageLevel
                    ? {
                        level: voltageLevel.toString(),
                        name: voltageLevel.toString(),
                        id: voltageLevel,
                      }
                    : null,
                };
              })
          : [],

        stuVoltage: Array.isArray(consumerData.stuVoltageLevel)
          ? consumerData.stuVoltageLevel.map((voltage) => {
              if (typeof voltage === "string") {
                return { level: voltage, name: voltage, id: voltage };
              } else if (typeof voltage === "number") {
                return {
                  level: voltage.toString(),
                  name: voltage.toString(),
                  id: voltage,
                };
              }
              return voltage;
            })
          : [],
        stateList: [],
        discomList: [],
        bankName: consumerData.consumerBankDetails?.bankName || "",
        branchAddress:
          consumerData.consumerBankDetails?.branchAddress ||
          consumerData.consumerBankDetails?.branchName ||
          "",
        accountNumber: consumerData.consumerBankDetails?.accountNumber || "",
        payee: consumerData.consumerBankDetails?.payee || "",
        ifscCode: consumerData.consumerBankDetails?.ifscCode || "",
        bankDifferent: true,
        pan: consumerData.pan || "",
        gst: consumerData.gst || "",
        tan: consumerData.tan || "",
        panDocId: "",
        gstDocId: "",
        tanDocId: "",
        registered_address: officeAddress.address || "",
        registered_state: registeredStateObj || {},
        registered_city: registeredCityObj || {},
        registered_pincode: officeAddress.pinCode?.toString() || "",
        registered_tel: "",
        registered_email: officeAddress.email || "",
        registered_fax: "",
        registered_contact: officeAddress.contactPersonName || "",
        registered_contactPhone: "",
        registered_mobile: officeAddress.mobileNumber || "",
        registered_altMobile: officeAddress.alternateMobileNumber || "",
        correspondence_address:
          correspondenceAddress.address || officeAddress.address || "",
        correspondence_state:
          correspondenceStateObj || registeredStateObj || {},
        correspondence_city: correspondenceCityObj || registeredCityObj || {},
        correspondence_pincode:
          correspondenceAddress.pinCode?.toString() ||
          officeAddress.pinCode?.toString() ||
          "",
        correspondence_tel: "",
        correspondence_email:
          correspondenceAddress.email || officeAddress.email || "",
        correspondence_fax: "",
        correspondence_contact:
          correspondenceAddress.contactPersonName ||
          officeAddress.contactPersonName ||
          "",
        correspondence_contactPhone: "",
        correspondence_mobile:
          correspondenceAddress.mobileNumber ||
          officeAddress.mobileNumber ||
          "",
        correspondence_altMobile:
          correspondenceAddress.alternateMobileNumber ||
          officeAddress.alternateMobileNumber ||
          "",
      };
    }

    return {
      plantName: "",
      maxDrawal: "",
      pod: {},
      specification: {},
      region: {},
      state: {},
      discom: [],
      discomName: {},
      discomVoltage: [],
      istsVoltage: [],
      stuVoltage: [],
      stateList: [],
      discomList: [],
      bankName: "",
      branchAddress: "",
      accountNumber: "",
      payee: "",
      ifscCode: "",
      bankDifferent: true,
      pan: "",
      gst: "",
      tan: "",
      panDocId: "",
      gstDocId: "",
      tanDocId: "",
      registered_address: "",
      registered_state: {},
      registered_city: {},
      registered_pincode: "",
      registered_tel: "",
      registered_email: "",
      registered_fax: "",
      registered_contact: "",
      registered_contactPhone: "",
      registered_mobile: "",
      registered_altMobile: "",
      correspondence_address: "",
      correspondence_state: {},
      correspondence_city: {},
      correspondence_pincode: "",
      correspondence_tel: "",
      correspondence_email: "",
      correspondence_fax: "",
      correspondence_contact: "",
      correspondence_contactPhone: "",
      correspondence_mobile: "",
      correspondence_altMobile: "",
    };
  }, [
    editMode,
    entityData,
    publicData?.specification,
    publicData?.region,
    publicData?.stateUT,
    publicData?.city,
    publicData?.discom,
  ]);

  const [totalLength, setTotalLength] = useState(["Consumer Details"]);
  const [errors, setErrors] = useState({});
  const [loading, setLoading] = useState(false);
  const [consumerDetails, setConsumerDetails] = useState([
    initialConsumerDetail(),
  ]);

  const [discomVoltage, setDiscomVoltage] = useState(() => {
    if (editMode && entityData) {
      const consumerData =
        entityData?.data?.data || entityData?.data || entityData;

      if (
        Array.isArray(consumerData?.discomDetails) &&
        consumerData.discomDetails.length > 0
      ) {
        const firstDiscom = consumerData.discomDetails[0];
        const discomObj = publicData?.discom?.find(
          (d) => d.id === firstDiscom.discomId,
        );

        return {
          discomId: discomObj || { id: firstDiscom.discomId },
          voltage: firstDiscom.voltageLevel
            ? {
                level: firstDiscom.voltageLevel,
                name: firstDiscom.voltageLevel,
                id: firstDiscom.voltageLevel,
              }
            : {},
        };
      }
    }

    return {
      discomId: {},
      voltage: {},
    };
  });

  const userData = useSelector((state) => state?.persistedReducer);

  const companyConGenId = userData?.company?.companyId || companyIdFromUrl;
  const userConGenId = userData?.user?.user?.userId || companyIdFromUrl;

  const [openDropdown, setOpenDropdown] = useState(null);
  const [activeType, setActiveType] = useState(null);

  const [consumerOptions, setConsumerOptions] = useState([]);
  const [generatorOptions, setGeneratorOptions] = useState([]);
  const [isLoading, setIsLoading] = useState(false);
  const [activeRelation, setActiveRelation] = useState("DIFFERENT");

  const [selectedConsumer, setSelectedConsumer] = useState(null);
  const [selectedGenerator, setSelectedGenerator] = useState(null);
  const [companyData, setCompanyData] = useState(null);
  const [error, setError] = useState(null);
  const [sameAsCompanyData, setSameAsCompanyData] = useState(null);

  const handleClick = async (type) => {
    setActiveType(type);
    setOpenDropdown(openDropdown === type ? null : type); // Toggle dropdown

    if (type === "CONSUMER") setSelectedConsumer(null);
    if (type === "GENERATOR") setSelectedGenerator(null);

    const targetCompanyId = companyId || companyIdFromUrl || companyConGenId;

    if (!targetCompanyId) {
      setError("Company ID is not set");
      return;
    }

    setIsLoading(true);
    setError(null);

    try {
      const res = await getWalletAccountsByCompanies([targetCompanyId]);

      const fetchedCompanyData = res?.data?.data?.find(
        (item) => item.companyId == targetCompanyId, // Use == for loose comparison
      );

      if (!fetchedCompanyData) {
        setError("Company data not found");
        return;
      }

      setCompanyData(fetchedCompanyData);
    } catch (err) {
      console.error("Wallet API error", err);
      setError("Failed to fetch wallet data: " + err.message);
      setConsumerOptions([]);
      setGeneratorOptions([]);
    } finally {
      setIsLoading(false);
    }
  };

  const handleFetchVoltages = useCallback(() => {
    if (!publicData?.voltage?.length) {
      dispatch(publicVoltage());
    }
  }, [publicData?.voltage?.length, dispatch]);

  const handleFetchRegions = useCallback(() => {
    if (!publicData?.region?.length) {
      dispatch(publicRegion());
    }
  }, [publicData?.region?.length, dispatch]);

  const handleFetchDiscoms = useCallback(() => {
    if (!publicData?.discom?.length) {
      dispatch(publicDiscom());
    }
  }, [publicData?.discom?.length, dispatch]);

  const handleFetchStates = useCallback(() => {
    if (!publicData?.stateUT?.length) {
      dispatch(publicStateUT());
    }
  }, [publicData?.stateUT?.length, dispatch]);

  const handleFetchSpecifications = useCallback(() => {
    if (!publicData?.specification?.length) {
      dispatch(publicSpecefication());
    }
  }, [publicData?.specification?.length, dispatch]);

  useEffect(() => {
    if (editMode && entityData) {
      const fetchDataAndInitialize = async () => {
        const consumerData =
          entityData?.data?.data || entityData?.data || entityData;

        if (!publicData?.specification?.length) {
          await dispatch(publicSpecefication());
        }
        if (!publicData?.region?.length) {
          await dispatch(publicRegion());
        }
        if (!publicData?.stateUT?.length) {
          await dispatch(publicStateUT());
        }
        if (!publicData?.voltage?.length) {
          await dispatch(publicVoltage());
        }
        if (!publicData?.discom?.length) {
          await dispatch(publicDiscom());
        }

        const officeAddress = consumerData?.consumerOfficeAddress || {};
        const correspondenceAddress =
          consumerData?.consumerCorrespondenceAddress || {};

        if (officeAddress.stateUtId) {
          await dispatch(publicCityById(officeAddress.stateUtId));
        }
        if (
          correspondenceAddress.stateUtId &&
          correspondenceAddress.stateUtId !== officeAddress.stateUtId
        ) {
          await dispatch(publicCityById(correspondenceAddress.stateUtId));
        }

        if (consumerData?.stateUtId) {
          await dispatch(publicDiscomByStateId(consumerData.stateUtId));
        }

        setConsumerDetails([initialConsumerDetail()]);
      };

      fetchDataAndInitialize();
    }
  }, [editMode, entityData, dispatch]);

  useEffect(() => {
    handleFetchRegions();
    handleFetchStates();
    handleFetchVoltages();
    handleFetchDiscoms();
    handleFetchSpecifications();
  }, []);
  const [discomsInitialized, setDiscomsInitialized] = useState(false);

  useEffect(() => {
    if (
      editMode &&
      entityData &&
      publicData?.discom?.length > 0 &&
      !discomsInitialized
    ) {
      const consumerData =
        entityData?.data?.data || entityData?.data || entityData;

      if (
        Array.isArray(consumerData?.discomDetails) &&
        consumerData.discomDetails.length > 0
      ) {
        setConsumerDetails((prev) => {
          const updated = [...prev];

          updated[0].discom = consumerData.discomDetails
            .filter((item) => item != null && typeof item === "object")
            .map((item) => {
              const discomObj = publicData?.discom?.find(
                (discom) => discom.id === item.discomId,
              );

              return {
                discomId: discomObj || {
                  id: item.discomId,
                  name: `DISCOM ${item.discomId}`,
                  acronym: `DISCOM ${item.discomId}`,
                },
                voltage: item.voltageLevel
                  ? {
                      level: item.voltageLevel,
                      name: item.voltageLevel,
                      id: item.voltageLevel,
                    }
                  : null,
              };
            });

          return updated;
        });
        setDiscomsInitialized(true);
      }
    }
  }, [editMode, entityData, publicData?.discom?.length, discomsInitialized]);

  useEffect(() => {
    if (editMode && entityData) {
      setConsumerDetails([initialConsumerDetail()]);

      const consumerData =
        entityData?.data?.data || entityData?.data || entityData;
      const officeAddress = consumerData?.consumerOfficeAddress || {};
      const correspondenceAddress =
        consumerData?.consumerCorrespondenceAddress || {};

      const addressesAreSame =
        officeAddress.address === correspondenceAddress.address &&
        officeAddress.stateUtId === correspondenceAddress.stateUtId &&
        officeAddress.cityId === correspondenceAddress.cityId &&
        officeAddress.pinCode === correspondenceAddress.pinCode &&
        officeAddress.email === correspondenceAddress.email &&
        officeAddress.contactPersonName ===
          correspondenceAddress.contactPersonName &&
        officeAddress.mobileNumber === correspondenceAddress.mobileNumber &&
        officeAddress.alternateMobileNumber ===
          correspondenceAddress.alternateMobileNumber;

      setSameCheck(addressesAreSame ? "same" : "different");
    }
  }, [editMode, entityData]);

  useEffect(() => {
    const targetCompanyId = companyId || companyIdFromUrl || companyConGenId;

    if (!targetCompanyId) return;

    getWalletAccountsByCompanies([targetCompanyId])
      .then((res) => {
        const fetchedCompanyData = res?.data?.data?.find(
          (item) => item.companyId == targetCompanyId, // Use == for loose comparison since URL param is string
        );

        setConsumerOptions(fetchedCompanyData?.consumerWalletAccounts || []);
        setGeneratorOptions(fetchedCompanyData?.generatorWalletAccounts || []);
        setCompanyData(fetchedCompanyData); // Add this line
      })
      .catch((err) => {
        console.error("Error fetching wallet accounts:", err);
        setConsumerOptions([]);
        setGeneratorOptions([]);
        setCompanyData(null); // Add this line
      });
  }, [companyId, companyIdFromUrl, companyConGenId]);
  useEffect(() => {
    if (activeRelation !== "SAME") return;

    const entityId = sameAsCompanyData?.id;
    const entityType = sameAsCompanyData?.type?.toLowerCase();

    if (!entityId || !entityType) return;

    const prefillFromEntity = async () => {
      try {
        let bankDetails, documents, gst, pan, tan;

        if (entityType === "consumer") {
          const res = await dispatch(fetchConsumer(entityId)).unwrap();
          const consumer = res?.consumerDetail?.data?.data;

          if (!consumer) {
            return;
          }

          bankDetails = consumer?.consumerBankDetails;
          documents = consumer?.consumerDocuments;
          gst = consumer?.gst;
          pan = consumer?.pan;
          tan = consumer?.tan;
        } else if (entityType === "generator") {
          const res = await dispatch(fetchGeneratorDetails(entityId)).unwrap();
          const generator = res?.generatorDetail?.data?.data;

          if (!generator) {
            return;
          }

          bankDetails = generator?.generatorBankDetails;
          documents = generator?.generatorDocuments;
          gst = generator?.gst;
          pan = generator?.pan;
          tan = generator?.tan;
        } else {
          return;
        }

        setConsumerDetails((prev) => {
          const updated = [...prev];

          updated[0] = {
            ...updated[0],

            bankName: bankDetails?.bankName || "",
            branchAddress: bankDetails?.branchAddress || "",
            accountNumber: bankDetails?.accountNumber || "",
            ifscCode: bankDetails?.ifscCode || "",
            payee: bankDetails?.payee || "",

            gst: gst || "",
            pan: pan || "",
            tan: tan || "",

            gstDocId: documents?.gstDocId || "",
            panDocId: documents?.panDocId || "",
            tanDocId: documents?.tanDocId || "",

            bankDifferent: true,
          };

          return updated;
        });
      } catch (err) {
        console.error(" Failed to prefill data:", err);
      }
    };

    prefillFromEntity();
  }, [
    activeRelation,
    sameAsCompanyData?.id,
    sameAsCompanyData?.type,
    dispatch,
  ]);

  useEffect(() => {
    if (activeRelation !== "SAME") return;

    const entityId = sameAsCompanyData?.id;
    const entityType = sameAsCompanyData?.type?.toLowerCase();

    if (!entityId || !entityType) return;

    if (entityType !== "consumer") return;

    // const prefillFromConsumer = async () => {
    //   try {
    //     const res = await dispatch(fetchConsumer(entityId)).unwrap();
    //     const consumer = res?.consumerDetail?.data?.data;

    //     if (!consumer) return;

    //     setConsumerDetails((prev) => {
    //       const updated = [...prev];

    //       updated[0] = {
    //         ...updated[0],

    //         bankName: consumer.consumerBankDetails?.bankName || "",
    //         branchAddress: consumer.consumerBankDetails?.branchAddress || "",
    //         accountNumber: consumer.consumerBankDetails?.accountNumber || "",
    //         ifscCode: consumer.consumerBankDetails?.ifscCode || "",
    //         payee: consumer.consumerBankDetails?.payee || "",

    //         gst: consumer.gst || "",
    //         pan: consumer.pan || "",
    //         tan: consumer.tan || "",

    //         gstDocId: consumer.consumerDocuments?.gstDocId || "",
    //         panDocId: consumer.consumerDocuments?.panDocId || "",
    //         tanDocId: consumer.consumerDocuments?.tanDocId || "",

    //         bankDifferent: true,
    //       };

    //       return updated;
    //     });
    //   } catch (err) {
    //     console.error("Failed to prefill consumer data", err);
    //   }
    // };

    // prefillFromConsumer();
  }, [
    activeRelation,
    sameAsCompanyData?.id,
    sameAsCompanyData?.type,
    dispatch,
  ]);

  useEffect(() => {
    if (activeRelation === "DIFFERENT") {
      setConsumerDetails((prev) => {
        const updated = [...prev];

        updated[0] = {
          ...updated[0],

          bankName: "",
          branchAddress: "",
          accountNumber: "",
          payee: "",
          ifscCode: "",

          gst: "",
          pan: "",
          tan: "",

          gstDocId: "",
          panDocId: "",
          tanDocId: "",

          bankDifferent: false,
        };

        return updated;
      });
    }
  }, [activeRelation]);

  const handleFieldChange = (index, field, value) => {
    const updatedDetails = [...consumerDetails];
    updatedDetails[index][field] = value;
    setConsumerDetails(updatedDetails);

    setErrors((prevErrors) => {
      const newErrors = { ...prevErrors };
      delete newErrors[`${field}_${index}`];
      return newErrors;
    });
  };

  const handleChange = (index, type, value) => {
    const updatedConsumerDetails = [...consumerDetails];

    if (type === "poi") {
      const voltageType = `${value.toLowerCase()}Voltage`;
      if (!updatedConsumerDetails[index][voltageType]) {
        updatedConsumerDetails[index][voltageType] = [];
      }
      // Clear POI error when a POI is selected
      setErrors((prev) => {
        const newErrors = { ...prev };
        delete newErrors[`poi_${index}`];
        return newErrors;
      });
    }

    // When state changes, fetch new discoms but keep existing selections
    if (type === "state") {
      // Clear only the current dropdown selection, not the history
      setDiscomVoltage({
        discomId: {},
        voltage: {},
      });

      // Fetch new discoms for the selected state
      if (value?.id) {
        handleGetDiscomByStateId(value);
      }
    }

    updatedConsumerDetails[index][type] = value;

    setConsumerDetails(updatedConsumerDetails);
    setErrors((prev) => {
      const newErrors = { ...prev };
      delete newErrors[`${type}_${index}`];
      return newErrors;
    });
  };

  const handleDiscomChange = (index, type, value) => {
    const updatedDiscomVoltage = { ...discomVoltage };
    updatedDiscomVoltage[type] = value;

    if (type === "discomId") {
      updatedDiscomVoltage.voltage = {};
      handleChange(index, "discomName", value);
    }

    setDiscomVoltage(updatedDiscomVoltage);

    if (type === "voltage" && value?.id) {
      const updatedConDetails = [...consumerDetails];

      const selectedDiscom = updatedDiscomVoltage?.discomId;

      if (!selectedDiscom) {
        console.error("No discom selected when trying to add voltage");
        return;
      }

      // Check for duplicate voltage level for the same DISCOM
      const duplicateVoltageForDiscom = updatedConDetails[index].discom?.find(
        (item) =>
          item.discomId?.id === selectedDiscom?.id &&
          item.voltage?.id === value?.id,
      );

      if (duplicateVoltageForDiscom) {
        // Same voltage level already selected for this DISCOM
        toast.error(
          `Voltage level "${value.level}" is already selected for this DISCOM`,
          toastProperties,
        );
        return;
      }

      const discomObject = {
        discomId: selectedDiscom,
        voltage: value,
      };

      if (!Array.isArray(updatedConDetails[index].discom)) {
        updatedConDetails[index].discom = [];
      }

      updatedConDetails[index].discom = [
        ...updatedConDetails[index].discom,
        discomObject,
      ];

      setDiscomVoltage({
        discomId: {},
        voltage: {},
      });
      setConsumerDetails(updatedConDetails);

      // Clear voltage error since we now have at least one discom voltage
      setErrors((prev) => {
        const newErrors = { ...prev };
        delete newErrors[`voltage_${index}`];
        return newErrors;
      });
    }
  };

  const handleAddUser = () => {
    setTotalLength((prev) => [...prev, "Consumer Details"]);
    setConsumerDetails((prev) => {
      const baseConsumer = prev[0] || initialConsumerDetail();
      const newConsumer = JSON.parse(JSON.stringify(baseConsumer));
      return [...prev, newConsumer];
    });
  };

  const handleRemoveUser = (index) => {
    if (consumerDetails.length > 1) {
      const updatedDetails = consumerDetails.filter((_, i) => i !== index);
      setConsumerDetails(updatedDetails);
      setTotalLength((prev) => prev.filter((_, i) => i !== index));

      const updatedErrors = { ...errors };
      Object.keys(updatedErrors).forEach((key) => {
        if (key.endsWith(`_${index}`)) {
          delete updatedErrors[key];
        }
        if (key.includes("_") && parseInt(key.split("_").pop()) > index) {
          const newKey = key.replace(
            /_\d+$/,
            `_${parseInt(key.split("_").pop()) - 1}`,
          );
          updatedErrors[newKey] = updatedErrors[key];
          delete updatedErrors[key];
        }
      });
      setErrors(updatedErrors);
    }
  };

  const handleGetStateByRegionId = useCallback(
    (id) => {
      dispatch(publicStateByRegionId(id?.id));
    },
    [dispatch],
  );

  const handleGetDiscomByStateId = useCallback(
    (id) => {
      const stateId = id?.id ?? id;
      if (!stateId) return;
      dispatch(publicDiscomByStateId(stateId));
    },
    [dispatch],
  );

  const renderTextInput = (
    index,
    field,
    heading,
    example,
    type = "text",
    readOnly = false,
    disabled = false,
  ) => (
    <TextInput
      heading={`${heading}`}
      value={consumerDetails[index][field]}
      onChange={(value) => handleChange(index, field, value)}
      example={example}
      type={type}
      height="45"
      error={errors[`${field}_${index}`]}
      readOnly={readOnly}
      disabled={readOnly || disabled}
    />
  );

  const sanitizeListForSelect = (list, type) => {
    if (!Array.isArray(list)) return [];

    return list
      .filter((item) => item && typeof item === "object")
      .map((item) => {
        const safeItem = { ...item };

        if (type === "discomId") {
          const displayName =
            item?.acronym || item?.discomName || item?.name || "Unknown Discom";
          safeItem.acronym = String(displayName);
          safeItem.name = String(displayName);
          safeItem.id = item?.id || item?.discomId;
        } else if (type === "voltage") {
          if (
            typeof item === "object" &&
            Object.keys(item).some((key) => !isNaN(key))
          ) {
            console.warn("Found array-like voltage object, converting:", item);
            const cleanItem = {};
            Object.keys(item).forEach((key) => {
              if (isNaN(key)) {
                cleanItem[key] = item[key];
              }
            });

            const displayLevel =
              cleanItem?.level ||
              cleanItem?.name ||
              cleanItem?.value ||
              cleanItem?.voltageLevelName ||
              cleanItem?.voltageLevel ||
              cleanItem?.voltage ||
              cleanItem?.displayName ||
              "Unknown Voltage";

            return {
              id:
                cleanItem?.id ||
                cleanItem?.voltageLevelId ||
                cleanItem?.voltageId ||
                Math.random(),
              level: String(displayLevel),
              name: String(displayLevel),
            };
          }

          const displayLevel =
            item?.level ||
            item?.name ||
            item?.value ||
            item?.voltageLevelName ||
            item?.voltageLevel ||
            item?.voltage ||
            item?.displayName ||
            item?.voltageLevelVal ||
            item?.val ||
            item?.text ||
            `${item?.id || "Unknown"}`;
          safeItem.level = String(displayLevel);
          safeItem.name = String(displayLevel);

          safeItem.id = item?.id || item?.voltageLevelId || item?.voltageId;
        } else {
          const displayName =
            item?.name || item?.label || item?.value || "Unknown";
          safeItem.name = String(displayName);
        }

        return safeItem;
      });
  };

  const renderSelectInput = (
    index,
    type,
    list,
    example,
    heading,
    recurring,
    disabledCondition = false,
    onFocus = null,
  ) => {
    const safeList = sanitizeListForSelect(list, type);

    let isDisabled = disabledCondition;

    if (recurring === "discom") {
      if (type === "discomId") {
        isDisabled = !consumerDetails[index]?.state?.id;
      } else if (type === "voltage") {
        const hasSelectedDiscom =
          discomVoltage?.discomId?.id || consumerDetails[index]?.discomName?.id;
        isDisabled = !hasSelectedDiscom;
      }
    }

    if (type === "discomId") {
      const invalidItems = list?.filter(
        (item) =>
          !item ||
          typeof item !== "object" ||
          (!item.acronym && !item.name && !item.discomName),
      );

      if (invalidItems?.length > 0) {
        console.error("Found invalid discom items:", invalidItems);
      }
    }

    return (
      <SelectInput
        onChange={(value) => {
          if (recurring === "discom") {
            handleDiscomChange(index, type, value);
          } else {
            handleChange(index, type, value);
            if (type === "region") {
              handleGetStateByRegionId(value);
            } else if (type === "state") {
              handleGetDiscomByStateId(value);
            }
          }
        }}
        onFocus={onFocus}
        list={safeList}
        value={(() => {
          const val = discomVoltage[type] || consumerDetails[index][type];

          if (type === "discomId" && val && typeof val === "object") {
            const displayName =
              val.acronym || val.name || val.discomName || "Unknown";
            return {
              ...val,
              acronym: String(displayName),
              name: String(displayName),
              id: val.id || val.discomId,
            };
          }

          return val;
        })()}
        example={isDisabled ? "Please select required field first" : example}
        heading={`${heading}`}
        height="45px"
        error={errors[`${type}_${index}`]}
        disabled={isDisabled}
      />
    );
  };

  const renderFileUpload = (index, heading, field, example, type, ID) => (
    <Fileupload
      heading={heading}
      value={consumerDetails[index][field]}
      onChange={(value) => handleFieldChange(index, field, value)}
      height="45"
      example={example}
      type={type}
      id={ID}
      error={errors[`${field}_${index}`]}
    />
  );

  const transformToApiPayload = () => {
    const consumerData = consumerDetails[0] || {};
    const existingData =
      editMode && entityData
        ? entityData.data?.data || entityData.data || entityData
        : {};

    const basePayload = {
      consumerId: editMode ? existingData.consumerId || null : null,
      companyId: companyId || (editMode ? existingData.companyId : null),
      uniqueId: editMode
        ? existingData.uniqueId
        : `CON${Date.now()}${Math.floor(Math.random() * 1000)}`,
      consumerName: consumerData.plantName || "",
      maxCapDrawl: parseFloat(consumerData.maxDrawal || 0),
      pointValue: consumerData.pod?.label || "DISCOM",
      specificationId: parseInt(consumerData.specification?.id || 0),
      stateUtId: parseInt(consumerData.state?.id || 0),
      pan: consumerData.pan || "",
      tan: consumerData.tan || "",
      gst: consumerData.gst || "",
      cloneConsumerId:
        sameAsCompanyData?.type?.toLocaleLowerCase() === "consumer"
          ? sameAsCompanyData?.id
          : null,
      cloneGeneratorId:
        sameAsCompanyData?.type?.toLocaleLowerCase() === "generator"
          ? sameAsCompanyData?.id
          : null,
    };

    if (isSuperAdmin && authUser) {
      const userId =
        authUser.userId ||
        authUser.id ||
        authUser.user?.userId ||
        authUser.user?.id ||
        authUser.userDetails?.userId ||
        authUser.userDetails?.id;
      if (userId) {
        basePayload.userId = userId;
      } else {
        console.warn("No valid userId found in authUser:", authUser);
      }
    }

    return [
      {
        ...basePayload,

        consumerBankDetails: {
          bankAccountId: editMode
            ? existingData.consumerBankDetails?.bankAccountId || null
            : null,
          companyId: editMode ? existingData.companyId || null : null,
          consumerId: editMode ? existingData.consumerId || null : null,
          accountHolderName: consumerData.plantName || "",
          accountNumber: consumerData.accountNumber || "",
          payee: consumerData.payee || "",
          ifscCode: consumerData.ifscCode || "",
          bankName: consumerData.bankName || "",
          branchAddress: consumerData.branchAddress || "",
        },

        istsVoltageLevel: (consumerData.istsVoltage || []).map((voltage) =>
          typeof voltage === "object" ? voltage.level : voltage,
        ),
        stuVoltageLevel: (consumerData.stuVoltage || []).map((voltage) =>
          typeof voltage === "object" ? voltage.level : voltage,
        ),

        discomDetails: (consumerData.discom || [])
          .filter((discom) => discom && discom.discomId && discom.voltage)
          .map((discom) => ({
            discomId:
              typeof discom.discomId === "object"
                ? discom.discomId.id
                : discom.discomId,
            voltageLevel:
              typeof discom.voltage === "object"
                ? discom.voltage.level || discom.voltage.name
                : discom.voltage,
          })),

        consumerDocuments: {
          documentMappingId: editMode
            ? existingData.consumerDocuments?.documentMappingId || null
            : null,
          companyId: editMode ? existingData.companyId || null : null,
          consumerId: editMode ? existingData.consumerId || null : null,
          generatorId: null,
          panDocId: editMode
            ? existingData.consumerDocuments?.panDocId || null
            : null,
          tanDocId: editMode
            ? existingData.consumerDocuments?.tanDocId || null
            : null,
          gstDocId: editMode
            ? existingData.consumerDocuments?.gstDocId || null
            : null,
          membershipFormDocId: editMode
            ? existingData.consumerDocuments?.membershipFormDocId || null
            : null,
          undertakingDocId: editMode
            ? existingData.consumerDocuments?.undertakingDocId || null
            : null,
          proofOfPaymentDocId: editMode
            ? existingData.consumerDocuments?.proofOfPaymentDocId || null
            : null,
          tradingLicenseDocId: editMode
            ? existingData.consumerDocuments?.tradingLicenseDocId || null
            : null,
          nocDocs: editMode
            ? existingData.consumerDocuments?.nocDocs || null
            : null,
          otherFiles: editMode
            ? existingData.consumerDocuments?.otherFiles || null
            : null,
          aadhaarCard: "",
          panCard: "",
          gstCertificate: "",
        },

        consumerOfficeAddress: {
          addressId: editMode
            ? existingData.consumerOfficeAddress?.addressId || null
            : null,
          companyId: editMode ? existingData.companyId || null : null,
          consumerId: editMode ? existingData.consumerId || null : null,
          generatorId: null,
          type: "OFFICE",
          address: consumerData.registered_address || "",
          stateUtId: editMode
            ? existingData.stateUtId
            : consumerData.stateUtName?.id || null,
          stateUtName: editMode
            ? existingData.stateUtName
            : consumerData.stateUtName?.name || "",
          cityId: editMode
            ? existingData.cityId
            : consumerData.cityName?.id || null,
          cityName: editMode
            ? existingData.cityName
            : consumerData.cityName?.name || "",
          pinCode: consumerData.registered_pincode
            ? parseInt(consumerData.registered_pincode)
            : null,
          email: consumerData.registered_email || "",
          contactPersonName: consumerData.registered_contact || "",
          mobileNumber: consumerData.registered_mobile || "",
          alternateMobileNumber: consumerData.registered_altMobile || "",
        },

        consumerCorrespondenceAddress: {
          addressId: editMode
            ? existingData.consumerCorrespondenceAddress?.addressId || null
            : null,
          companyId: editMode ? existingData.companyId || null : null,
          consumerId: editMode ? existingData.consumerId || null : null,
          generatorId: null,
          type: "CORRESPONDENCE",
          address:
            consumerData.correspondence_address ||
            consumerData.registered_address ||
            "",
          stateUtId: consumerData.correspondence_state?.id
            ? parseInt(consumerData.correspondence_state.id)
            : consumerData.registered_state?.id
              ? parseInt(consumerData.registered_state.id)
              : null,
          cityId: consumerData.correspondence_city?.id
            ? parseInt(consumerData.correspondence_city.id)
            : consumerData.registered_city?.id
              ? parseInt(consumerData.registered_city.id)
              : null,
          pinCode: consumerData.correspondence_pincode
            ? parseInt(consumerData.correspondence_pincode)
            : consumerData.registered_pincode
              ? parseInt(consumerData.registered_pincode)
              : null,
          email:
            consumerData.correspondence_email ||
            consumerData.registered_email ||
            "",
          contactPersonName:
            consumerData.correspondence_contact ||
            consumerData.registered_contact ||
            "",
          mobileNumber:
            consumerData.correspondence_mobile ||
            consumerData.registered_mobile ||
            "",
          alternateMobileNumber:
            consumerData.correspondence_altMobile ||
            consumerData.registered_altMobile ||
            "",
        },
        isCompanyWallet:
          sameAsCompanyData?.type?.toLocaleLowerCase() === "company"
            ? true
            : false,
        createdAt: editMode ? existingData.createdAt : null,
        userCount: editMode ? existingData.userCount || 0 : 0,
        accountStatus: editMode
          ? existingData.accountStatus || "VERIFIED"
          : "VERIFIED",
      },
    ];
  };

  const walletPayload = () => {
    return {
      cloneConsumerId:
        sameAsCompanyData?.type?.toLowerCase() === "consumer"
          ? sameAsCompanyData?.id
          : null,

      cloneGeneratorId:
        sameAsCompanyData?.type?.toLowerCase() === "generator"
          ? sameAsCompanyData?.id
          : null,

      companyId: companyConGenId,

      consumerId:
        sameAsCompanyData?.type?.toLowerCase() === "consumer"
          ? sameAsCompanyData?.id
          : null,

      generatorId:
        sameAsCompanyData?.type?.toLowerCase() === "generator"
          ? sameAsCompanyData?.id
          : null,

      userId: userConGenId,
    };
  };

  const validateAllFields = () => {
    const newErrors = {};
    let hasErrors = false;

    consumerDetails.forEach((consumer, index) => {
      if (!consumer.plantName?.trim()) {
        newErrors[`plantName_${index}`] = "Consumer Name is required";
        hasErrors = true;
      }
      if (!consumer.maxDrawal?.trim()) {
        newErrors[`maxDrawal_${index}`] =
          "Maximum Capacity of Drawal is required";
        hasErrors = true;
      }
      if (!consumer.specification?.id) {
        newErrors[`specification_${index}`] = "Specification is required";
        hasErrors = true;
      }
      if (!consumer.region?.id) {
        newErrors[`region_${index}`] = "Region is required";
        hasErrors = true;
      }
      if (!consumer.state?.id) {
        newErrors[`state_${index}`] = "State is required";
        hasErrors = true;
      }

      if (!consumer.poi) {
        newErrors[`poi_${index}`] = "Point of Drawal is required";
        hasErrors = true;
      }

      const hasIstsVoltage =
        consumer.istsVoltage && consumer.istsVoltage.length > 0;
      const hasStuVoltage =
        consumer.stuVoltage && consumer.stuVoltage.length > 0;
      const hasDiscomVoltage = consumer.discom && consumer.discom.length > 0;

      if (!hasIstsVoltage && !hasStuVoltage && !hasDiscomVoltage) {
        newErrors[`voltage_${index}`] =
          "At least one voltage level is required";
        hasErrors = true;
      }

      if (activeRelation === "DIFFERENT") {
        if (!consumer.bankName?.trim()) {
          newErrors[`bankName_${index}`] = "Bank Name is required";
          hasErrors = true;
        }
        if (!consumer.branchAddress?.trim()) {
          newErrors[`branchAddress_${index}`] = "Branch Address is required";
          hasErrors = true;
        }
        if (!consumer.accountNumber?.trim()) {
          newErrors[`accountNumber_${index}`] = "Account Number is required";
          hasErrors = true;
        }
        if (!consumer.payee?.trim()) {
          newErrors[`payee_${index}`] = "Payee is required";
          hasErrors = true;
        }
        if (!consumer.ifscCode?.trim()) {
          newErrors[`ifscCode_${index}`] = "IFSC Code is required";
          hasErrors = true;
        }
        if (!consumer.pan?.trim()) {
          newErrors[`pan_${index}`] = "PAN is required";
          hasErrors = true;
        }
        if (!consumer.gst?.trim()) {
          newErrors[`gst_${index}`] = "GST is required";
          hasErrors = true;
        }
        if (!consumer.tan?.trim()) {
          newErrors[`tan_${index}`] = "TAN is required";
          hasErrors = true;
        }
      }

      if (!consumer.registered_address?.trim()) {
        newErrors[`registered_address_${index}`] =
          "Registered Address is required";
        hasErrors = true;
      }
      if (!consumer.registered_state?.id) {
        newErrors[`registered_state_${index}`] = "Registered State is required";
        hasErrors = true;
      }
      if (!consumer.registered_city?.id) {
        newErrors[`registered_city_${index}`] = "Registered City is required";
        hasErrors = true;
      }
      if (!consumer.registered_pincode?.trim()) {
        newErrors[`registered_pincode_${index}`] =
          "Registered Pincode is required";
        hasErrors = true;
      }
      if (!consumer.registered_email?.trim()) {
        newErrors[`registered_email_${index}`] = "Registered Email is required";
        hasErrors = true;
      }
      if (!consumer.registered_contact?.trim()) {
        newErrors[`registered_contact_${index}`] =
          "Contact Person Name is required";
        hasErrors = true;
      }
      if (!consumer.registered_mobile?.trim()) {
        newErrors[`registered_mobile_${index}`] = "Mobile Number is required";
        hasErrors = true;
      }

      if (sameCheck !== "same") {
        if (!consumer.correspondence_address?.trim()) {
          newErrors[`correspondence_address_${index}`] =
            "Correspondence Address is required";
          hasErrors = true;
        }
        if (!consumer.correspondence_state?.id) {
          newErrors[`correspondence_state_${index}`] =
            "Correspondence State is required";
          hasErrors = true;
        }
        if (!consumer.correspondence_city?.id) {
          newErrors[`correspondence_city_${index}`] =
            "Correspondence City is required";
          hasErrors = true;
        }
        if (!consumer.correspondence_pincode?.trim()) {
          newErrors[`correspondence_pincode_${index}`] =
            "Correspondence Pincode is required";
          hasErrors = true;
        }
        if (!consumer.correspondence_email?.trim()) {
          newErrors[`correspondence_email_${index}`] =
            "Correspondence Email is required";
          hasErrors = true;
        }
        if (!consumer.correspondence_contact?.trim()) {
          newErrors[`correspondence_contact_${index}`] =
            "Correspondence Contact Person is required";
          hasErrors = true;
        }
        if (!consumer.correspondence_mobile?.trim()) {
          newErrors[`correspondence_mobile_${index}`] =
            "Correspondence Mobile is required";
          hasErrors = true;
        }
      }
    });

    setErrors(newErrors);
    return !hasErrors;
  };

  const handleSubmit = async (e) => {
    e.preventDefault();

    if (!validateAllFields()) {
      toast.error("Please fill in all required fields");
      return;
    }

    setLoading(true);

    try {
      const payload = transformToApiPayload();

      if (editMode) {
        if (isSuperAdmin) {
          await updateConsumerSuperAdmin(payload[0]);
        } else {
          await updateConsumer(payload[0]);
        }
      } else {
        if (isSuperAdmin) {
          await addConsumerSuperAdmin(payload, companyId);
        } else {
          await addConsumer(payload);
        }
      }

      if (isSuperAdmin) {
        const targetCompanyId =
          companyId || payload[0]?.companyId || payload?.companyId;

        if (targetCompanyId) {
          dispatch(fetchConsumersCompanyId(targetCompanyId));
        }
      } else {
        dispatch(fetchConsumers());
      }

      dispatch(fetchSideBarConsumerList());

      if (handleClose) handleClose();
    } catch (error) {
      console.error(
        editMode ? "Error updating consumer:" : "Error creating consumer:",
        error,
      );

      toast.error(
        editMode
          ? "Error updating consumer. Please try again."
          : "Error creating consumer. Please try again.",
      );
    } finally {
      setLoading(false);
    }
  };

  const renderConsumerDetail = (ele, index) => {
    return (
      <div className={` ${Styles.conContentSection}`} key={index}>
        {!editMode && (
          <div className={`${Styles.alterSection} ${Styles.alterSectionOther}`}>
            {totalLength.length > 1 && (
              <div
                className={Styles.deleteSection}
                onClick={() => handleRemoveUser(index)}
              >
                <RemoveIcon style={{ fontSize: "16px" }} />
              </div>
            )}
            {/* <div
            className={`${Styles.addSection} ${Styles.AddnewGenSection}`}
            onClick={handleAddUser}
          >
            <Add style={{ fontSize: "14px" }} />
            <span className={Styles.addNewHeading}>Add New Consumer</span>
          </div> */}
          </div>
        )}

        {/* Basic Details */}
        <div className={Styles.layer2ElementsContainer}>
          {renderTextInput(
            index,
            "plantName",
            "Consumer Name",
            "Eg. GNA Energy",
          )}
          {renderTextInput(
            index,
            "maxDrawal",
            "Maximum Capacity of Drawal (MW)",
            "Eg. 1000000",
          )}
        </div>

        <div className={Styles.layer2ElementsContainer}>
          {renderSelectInput(
            index,
            "specification",
            publicData?.specification?.filter(
              (ele) => ele?.type === "CONSUMER",
            ),
            "Select Specification",
            "Specification",
            null,
            false,
            handleFetchSpecifications,
          )}
          {renderSelectInput(
            index,
            "region",
            publicData?.region,
            "Select Region",
            "Region",
            null,
            false,
            handleFetchRegions,
          )}
        </div>

        {/* Point of Drawal Section */}
        <div className={Styles.layer3ElementsContainer}>
          <div className={Styles.checkBoxElem}>
            <div className={Styles.checkBoxHead}>Point Of Drawal (POD)*</div>
            <div className={Styles.selectCheckElemEent}>
              {["ISTS", "STU", "DISCOM"].map((poiType) => (
                <div
                  key={poiType}
                  onClick={() => handleChange(index, "poi", poiType)}
                  style={{ width: "30%" }}
                  className={
                    consumerDetails[index].poi === poiType
                      ? Styles.activeCheck
                      : Styles.inactiveCheck
                  }
                >
                  {poiType}
                </div>
              ))}
            </div>
            {errors[`poi_${index}`] && (
              <span className={Styles.errorPass}>{errors[`poi_${index}`]}</span>
            )}
          </div>

          {/* Voltage Selection */}
          <div>
            {(consumerDetails[index].poi === "ISTS" ||
              consumerDetails[index].poi === "STU") && (
              <SelectInput
                onChange={(value) => {
                  const updatedVoltages = [...consumerDetails];
                  const voltageType = `${consumerDetails[
                    index
                  ].poi.toLowerCase()}Voltage`;

                  if (!updatedVoltages[index][voltageType]) {
                    updatedVoltages[index][voltageType] = [];
                  }

                  const currentVoltages = updatedVoltages[index][voltageType];

                  const isAlreadySelected = currentVoltages.some(
                    (v) => (v?.id || v) === (value?.id || value),
                  );

                  if (isAlreadySelected) {
                    updatedVoltages[index][voltageType] =
                      currentVoltages.filter(
                        (v) => (v?.id || v) !== (value?.id || value),
                      );
                  } else {
                    updatedVoltages[index][voltageType] = [
                      ...currentVoltages,
                      value,
                    ];
                  }

                  setConsumerDetails(updatedVoltages);

                  // Clear voltage error if at least one voltage is selected
                  if (updatedVoltages[index][voltageType].length > 0) {
                    setErrors((prev) => {
                      const newErrors = { ...prev };
                      delete newErrors[`voltage_${index}`];
                      return newErrors;
                    });
                  }
                }}
                list={publicData?.voltage}
                value={{}}
                example={"Select Voltage Levels"}
                heading={`${consumerDetails[index].poi} Voltage`}
                height={"45px"}
                multiple
              />
            )}
          </div>

          {/* Voltage Display */}
          {(consumerDetails[index].poi === "ISTS" ||
            consumerDetails[index].poi === "STU") && (
            <div className={Styles.layerscrollElements}>
              {(Array.isArray(
                consumerDetails[index][
                  `${consumerDetails[index].poi.toLowerCase()}Voltage`
                ],
              )
                ? consumerDetails[index][
                    `${consumerDetails[index].poi.toLowerCase()}Voltage`
                  ]
                : []
              ).map((ele, voltageIndex) => (
                <div key={voltageIndex} className={Styles.eachLevelLayer}>
                  <span>{ele.level}</span>
                  <Close
                    style={{ fontSize: "14px", cursor: "pointer" }}
                    onClick={() => {
                      const updatedVoltages = [...consumerDetails];
                      const voltageType = `${consumerDetails[
                        index
                      ].poi.toLowerCase()}Voltage`;
                      updatedVoltages[index][voltageType] = updatedVoltages[
                        index
                      ][voltageType].filter((_, i) => i !== voltageIndex);
                      setConsumerDetails(updatedVoltages);
                    }}
                  />
                </div>
              ))}
            </div>
          )}

          {/* Voltage Level Error Display */}
          {errors[`voltage_${index}`] && (
            <div
              className="errorHeading"
              style={{ color: "red", fontSize: "12px", marginTop: "5px" }}
            >
              {errors[`voltage_${index}`]}
            </div>
          )}
        </div>

        <div className={Styles.divider}></div>

        {/* Discom Selection */}
        <div className={Styles.discomSelectionContainer}>
          <div className={Styles.subConterntHeader}>Discom Voltage</div>
          <div className={Styles.layer3ElementsContainer}>
            {renderSelectInput(
              index,
              "state",
              publicData?.stateUT,
              "Select State",
              "State",
              null,
              false,
              handleFetchStates,
            )}

            {renderSelectInput(
              index,
              "discomId",
              (publicData?.discom || [])
                .filter((discom) => discom && typeof discom === "object")
                .map((discom) => {
                  const displayName =
                    discom?.acronym ||
                    discom?.discomName ||
                    discom?.name ||
                    "Unknown Discom";

                  return {
                    ...discom,
                    acronym: String(displayName),
                    name: String(displayName),
                    id: discom?.id || discom?.discomId,
                  };
                }),
              "Select Discom",
              "Discom",
              "discom",
              !consumerDetails[index]?.state?.id,
              handleFetchDiscoms,
            )}

            {renderSelectInput(
              index,
              "voltage",
              publicData?.voltage || [],
              "Select Voltage Level",
              "Voltage Level",
              "discom",
              // !consumerDetails[index]?.state?.id ||
              //   !discomVoltage[index]?.discomId,
              undefined,
              handleFetchVoltages,
            )}
          </div>

          <div className={Styles.voltageOverflow}>
            {Array.isArray(consumerDetails[index]?.discom) &&
              consumerDetails[index].discom.map((ele, discomIndex) => (
                <div key={discomIndex} className={Styles.voltageSection}>
                  <div className={Styles.actVoltageLevel}>
                    <div>
                      {(() => {
                        const voltage = ele?.voltage;
                        if (typeof voltage === "string") return voltage;
                        if (typeof voltage === "number")
                          return voltage.toString();
                        if (typeof voltage === "object" && voltage !== null) {
                          return (
                            voltage?.level ||
                            voltage?.label ||
                            voltage?.value ||
                            "N/A"
                          );
                        }
                        return "N/A";
                      })()}
                    </div>
                    <Close
                      style={{
                        fontSize: "12px",
                        color: "red",
                        cursor: "pointer",
                      }}
                      onClick={() => {
                        const updatedGeneratorDetails = [...consumerDetails];
                        updatedGeneratorDetails[index].discom =
                          updatedGeneratorDetails[index].discom.filter(
                            (_, i) => i !== discomIndex,
                          );
                        setConsumerDetails(updatedGeneratorDetails);
                      }}
                    />
                  </div>
                  <div className={Styles.discomName}>
                    {(() => {
                      const discom = ele?.discomId;
                      if (typeof discom === "string") return discom;
                      if (typeof discom === "number") return discom.toString();
                      if (typeof discom === "object" && discom !== null) {
                        return (
                          discom?.acronym ||
                          discom?.discomName ||
                          discom?.name ||
                          "N/A"
                        );
                      }
                      return "N/A";
                    })()}
                  </div>
                </div>
              ))}
          </div>
        </div>

        {/* Bank Details */}
        <div className={Styles.corrAddressContainer}>
          <div
            className={`${Styles.subConterntHeader} ${Styles.corrOtherHeading}`}
          >
            Bank Details
          </div>
          <div className={Styles.button_Section}>
            {!editMode && (
              <div className={Styles.dropdownWrapper}>
                <span
                  className={
                    activeRelation === "SAME" ? Styles.active : Styles.inActive
                  }
                  onClick={(e) => {
                    e.stopPropagation();
                    handleClick("SAME");
                    setActiveRelation("SAME");
                    setOpenDropdown(openDropdown === "SAME" ? null : "SAME");
                  }}
                >
                  {sameAsCompanyData
                    ? `${sameAsCompanyData.type} - ${sameAsCompanyData.data}`
                    : "Existing"}
                </span>

                {openDropdown && activeType === "SAME" && (
                  <div className={Styles.dropdownBox}>
                    {isLoading ? (
                      <div className={Styles.dropdownItem}>Loading...</div>
                    ) : error ? (
                      <div className={Styles.dropdownItem}>{error}</div>
                    ) : companyData ? (
                      <>
                        {/* <div
                      onClick={() => {
                        setOpenDropdown(false);
                        setActiveRelation("SAME");
                        setSameAsCompanyData({
                          type: "COMPANY",
                          data: companyData?.companyName,
                          id: companyData?.companyId,
                        });
                      }}
                      className={Styles.dropdownItem}
                    >
                      <strong>Company:</strong> {companyData.companyName}
                    </div> */}
                        {companyData?.consumerWalletAccounts?.map((i) => {
                          return (
                            <div
                              onClick={() => {
                                setOpenDropdown(false);

                                setActiveRelation("SAME");
                                setSameAsCompanyData({
                                  type: "CONSUMER",
                                  data: i?.consumerName,
                                  id: i?.consumerId,
                                });
                              }}
                              className={Styles.dropdownItem}
                            >
                              <strong>Consumer:</strong>{" "}
                              {i?.consumerName || "-"}
                            </div>
                          );
                        })}
                        {companyData?.generatorWalletAccounts?.map((i) => {
                          return (
                            <div
                              onClick={() => {
                                setOpenDropdown(false);

                                setActiveRelation("SAME");
                                setSameAsCompanyData({
                                  type: "GENERATOR",
                                  data: i?.generatorName,
                                  id: i?.generatorId,
                                });
                              }}
                              className={Styles.dropdownItem}
                            >
                              <strong>Generator:</strong>{" "}
                              {i?.generatorName || "-"}
                            </div>
                          );
                        })}
                      </>
                    ) : (
                      <div className={Styles.dropdownItem}>
                        No company data available
                      </div>
                    )}
                  </div>
                )}
              </div>
            )}

            {!editMode && (
              <span
                className={activeRelation === "DIFFERENT" ? Styles.active : ""}
                onClick={() => {
                  setActiveRelation("DIFFERENT");
                  setOpenDropdown(null);
                  setSameAsCompanyData(null);
                }}
              >
                New
              </span>
            )}
          </div>

          <div className={Styles.corrAddSelection}>
            {/* <div className={Styles.officeSelectionText}>
            <div>
              Same as the <b>Company</b> bank details
            </div>
            <div className={Styles.sel_button}>
              {["Yes", "No"].map((option) => (
                <span
                  key={option}
                  onClick={() => {
                    const updatedConsumerDetails = [...consumerDetails];
                    updatedConsumerDetails[index].bankDifferent =
                      option === "No";
                    setConsumerDetails(updatedConsumerDetails);
                  }}
                  className={
                    (
                      option === "Yes"
                        ? !consumerDetails[index].bankDifferent
                        : consumerDetails[index].bankDifferent
                    )
                      ? Styles.active_corr
                      : Styles.inAct_corr
                  }
                >
                  {option}
                </span>
              ))}
            </div>
          </div> */}
          </div>
        </div>
        <div className={Styles.divider}></div>

        {
          <>
            {
              <>
                <div className={Styles.layer2ElementsContainer}>
                  {renderTextInput(
                    index,
                    "bankName",
                    "Bank Name",
                    "Eg. State Bank of India",
                    "text",
                    activeRelation === "SAME",
                    editMode,
                  )}
                  {renderTextInput(
                    index,
                    "branchAddress",
                    "Bank Address",
                    "Eg. 123 Main Street, City",
                    "text",
                    activeRelation === "SAME",
                    editMode,
                  )}
                </div>
                <div className={Styles.layer3ElementsContainer}>
                  {renderTextInput(
                    index,
                    "accountNumber",
                    "Account Number",
                    "Eg. 1234567890",
                    "number",
                    activeRelation === "SAME",
                    editMode,
                  )}
                  {renderTextInput(
                    index,
                    "payee",
                    "Payee Name",
                    "Eg. John Doe",
                    "text",
                    activeRelation === "SAME",
                    editMode,
                  )}
                  {renderTextInput(
                    index,
                    "ifscCode",
                    "IFSC Code",
                    "Eg. SBIN0001234",
                    "text",
                    activeRelation === "SAME",
                    editMode,
                  )}
                </div>
                <div className={Styles.layer3ElementsContainer}>
                  {renderTextInput(
                    index,
                    "gst",
                    "GST Number",
                    "Eg. 123456789012345",
                    "text",
                    activeRelation === "SAME",
                    editMode,
                  )}
                  {renderTextInput(
                    index,
                    "pan",
                    "PAN Number",
                    "Eg. ABCDE1234F",
                    "text",
                    activeRelation === "SAME",
                    editMode,
                  )}
                  {renderTextInput(
                    index,
                    "tan",
                    "TAN Number",
                    "Eg. ABCDE1234F",
                    "text",
                    activeRelation === "SAME",
                    editMode,
                  )}
                </div>
                <div className={Styles.layer3ElementsContainer}>
                  {renderFileUpload(
                    index,
                    "GST Certificate Copy",
                    "gstDocId",
                    "Upload GST (.pdf accepted)",
                    "GST",
                    "gstDocId",
                    editMode,
                  )}
                  {renderFileUpload(
                    index,
                    "PAN Card Copy",
                    "panDocId",
                    "Upload PAN (.pdf accepted)",
                    "PAN",
                    "panDocId",
                    editMode,
                  )}
                  {renderFileUpload(
                    index,
                    "TAN Card Copy",
                    "tanDocId",
                    "Upload TAN (.pdf accepted)",
                    "TAN",
                    "tanDocId",
                    editMode,
                  )}
                </div>
              </>
            }
          </>
        }

        <div
          className={`${Styles.conContainerAddressSection} ${Styles.conAddressContainer}`}
        >
          <div
            className={`${Styles.subConterntHeader} ${Styles.corrOtherHeading}`}
          >
            Registered Address
          </div>
          <div className={Styles.divider}></div>
          <AddressSection
            prefix="registered"
            addressData={consumerDetails[index]}
            handleChange={handleChange}
            errors={errors}
            publicData={publicData}
            index={index}
          />
          <div className={Styles.corrAddressContainer}>
            <div
              className={`${Styles.subConterntHeader} ${Styles.corrOtherHeading}`}
            >
              Correspondence Address
            </div>
            <div className={Styles.corrAddSelection}>
              <div className={Styles.officeSelectionText}>
                <div>Same as that of Office Address</div>
                <div className={Styles.sel_button}>
                  <span
                    onClick={() => setSameCheck("same")}
                    className={
                      sameCheck === "same"
                        ? Styles.active_corr
                        : Styles.inAct_corr
                    }
                  >
                    Yes
                  </span>
                  <span
                    onClick={() => setSameCheck("different")}
                    className={
                      sameCheck === "different"
                        ? Styles.active_corr
                        : Styles.inAct_corr
                    }
                  >
                    No
                  </span>
                </div>
              </div>
            </div>
          </div>
          <div className={Styles.divider}></div>
          {sameCheck === "different" && (
            <AddressSection
              prefix="correspondence"
              addressData={consumerDetails[index]}
              handleChange={handleChange}
              errors={errors}
              publicData={publicData}
              index={index}
            />
          )}
        </div>

        {/* {totalLength === 0 && (
        <div className={Styles.AddMoreCont} onClick={handleAddUser}>
          <Add style={{ fontSize: "14px" }} />
          <span>Add New Consumer</span>
        </div>
      )} */}
      </div>
    );
  };

  return (
    <div className={isModal ? Styles.modalElementMain : Styles.elementMain}>
      <div className={isModal ? Styles.modalModalHeader : Styles.modalHeader}>
        <div>
          {/* <h2 className={Styles.addEntityTitle}>Add Entity</h2> */}
          <div className={Styles.entityTabs}>
            <div>{editMode ? "Edit Entity" : "Add Entity"}</div>
            {!hideSelection && (
              <>
                {!editMode && (
                  <div className={`${Styles.entityTab} ${Styles.activeTab}`}>
                    Consumer
                  </div>
                )}
                {!editMode && (
                  <div
                    className={Styles.entityTab}
                    onClick={() => onSwitchToGenerator && onSwitchToGenerator()}
                  >
                    Generator
                  </div>
                )}
              </>
            )}
          </div>
        </div>
        <div style={{ width: "5%" }}>
          <Close
            onClick={handleClose}
            style={{ cursor: "pointer", marginLeft: "auto", color: "#777777" }}
          />
        </div>
      </div>

      {/* Form Content with Fixed Layout */}
      <div
        className={
          isModal
            ? Styles.modalCompanyAdminFormLayout
            : Styles.companyAdminFormLayout
        }
      >
        {/* Form Content - Scrollable Area */}
        <div className={Styles.companyAdminFormContent}>
          {totalLength.map((ele, index) => renderConsumerDetail(ele, index))}
        </div>

        <div
          className={
            isModal
              ? Styles.modalCompanyAdminButtonSection
              : Styles.companyAdminButtonSection
          }
        >
          <div
            className={`${
              isModal ? Styles.modalBtnSection : Styles.btnSection
            }  ${Styles.prevBtn}`}
            onClick={handleClose}
          >
            Cancel
          </div>
          <div
            className={`${
              isModal ? Styles.modalBtnSection : Styles.btnSection
            } ${Styles.nextBtn}`}
            onClick={handleSubmit}
          >
            {loading
              ? editMode
                ? "Updating..."
                : "Creating..."
              : editMode
                ? "Update"
                : "Create"}
          </div>
        </div>
      </div>
    </div>
  );
};

export default CompanyAdminConsumerForm;
